import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { MicrosoftService } from '../services/microsoft.service';

@Injectable({
    providedIn: 'root'
})
export class isAzureAuthenticatedGuard implements CanActivate, CanActivateChild {
	constructor(private microsoftService: MicrosoftService,
				private router: Router) {}

    canActivate(): boolean | Observable<boolean> {
		if(this.microsoftService.isAuthenticated instanceof Observable)
			return this.microsoftService.isAuthenticated.pipe(tap(isAuthenticated => {
						if(!isAuthenticated)
							this.router.navigate(['/fail/403']);
					}));

		else if(!this.microsoftService.isAuthenticated)
			this.router.navigate(['/fail/403']);

		return this.microsoftService.isAuthenticated;
	}

	canActivateChild(): boolean | Observable<boolean> { return this.canActivate(); }
}